import { settleManually } from "@/services/settlements.service";
import { useMutation, useQueryClient } from "@tanstack/react-query";


export const useManualSettlement = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: settleManually,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["settlements"] });
      queryClient.invalidateQueries({ queryKey: ["settlementStats"] });
      queryClient.invalidateQueries({ queryKey: ["settlement"] });
      queryClient.invalidateQueries({ queryKey: ["transactions"] });
      queryClient.invalidateQueries({ queryKey: ["transactionStats"] });
    },
  });
};